import React from 'react'
import { Popper, ClickAwayListener, PopperProps } from '@material-ui/core'

export interface CustomPopperProps extends Omit<PopperProps, 'children'> {
  onClickAway: () => void
  children: React.ReactNode
}

const CustomPopper = ({
  onClickAway,
  children,
  ...others
}: CustomPopperProps) => {
  return (
    <Popper {...others}>
      <ClickAwayListener onClickAway={onClickAway}>
        <div>{children}</div>
      </ClickAwayListener>
    </Popper>
  )
}

export default CustomPopper
